import { render, staticRenderFns } from "./ConfigurazioneQuiz.vue?vue&type=template&id=3bd41656&"
import script from "./ConfigurazioneQuiz.vue?vue&type=script&lang=js&"
export * from "./ConfigurazioneQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports